const setHelperText = (helperText?: string, touched = false, error?: string): string => {
  let renderHelperText = helperText;

  if (touched && error) {
    renderHelperText = error;
  }

  return renderHelperText;
};

export default setHelperText;
